import React, { Component } from 'react'
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl'
import createAxios from 'utils/axios'

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from 'components/dashboard/constants'

const isEmail = value => /^.+@.+\..+/.test(value)
const isPhone = value => {
  value = value.replace(/\D+/g, '').replace(/^86/, '')
  return /^\d{8,15}$/.test(value)
}

class IdentityForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.isChinaVersion ? '86' : '',
      valid: false,
      message: '',
      sent: false,
      fetching: false,
      newPassword: '',
    }
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  handleSubmit(e) {
    e.preventDefault()
    const { value, valid } = this.state

    if (!valid) { return }

    this.setState({ fetching: true, message: '' })

    const url = '/password_recovery'
    const payload = {}

    if (isEmail(value)) { payload.email = value }
    if (isPhone(value)) { payload.phone = value }

    this.axios.patch(url, payload).then(({ status }) => {
      if (status === 200) {
        this.setState({ sent: true, fetching: false })
      }
    })
  }

  handleChange(e) {
    const { value } = e.target
    const valid = isEmail(value) || isPhone(value)

    this.setState({ value, valid })
  }

  render() {
    const { value, valid, sent, fetching } = this.state

    return sent
      ? (
        <div>
          {this.props.isChinaVersion ? (
            <h4><FormattedMessage id="ForgotPassword.CheckYourPhone" /></h4>
          ) : (
            <h4><FormattedMessage id="ForgotPassword.CheckYourEmailOrPhone" /></h4>
          )}
          <a href={this.link('/login')} className='button button-dark-blue'>
            <FormattedMessage id="ForgotPassword.BackToLogin" />
          </a>
        </div>
      ) : (
      <form onSubmit={this.handleSubmit.bind(this)} className="form">
        <div className="form-group">
          {this.props.isChinaVersion ? (
            <p><FormattedMessage id="ForgotPassword.EnterPhone" /></p>
          ) : (
            <p><FormattedMessage id="ForgotPassword.EnterEmailOrPhone" /></p>
          )
          }

          <input
            value={value}
            onChange={(e) => this.handleChange(e)}
            type="text"
            autoFocus={!this.props.isChinaVersion} />
        </div>

        <input
          type="submit"
          className="button button-dark-blue"
          // value={this.t('ForgotPassword.ButtonText')}
          value={this.t('ForgotPassword.TryAgain')}
          disabled={!valid} />

        <div className="form__message">
          {fetching &&
            <div className="wrapper">
              <div className="cssload-loader"></div>
            </div>
          }
        </div>

        <div className="login__links">
          <a href={this.link('/login')}><FormattedMessage id="Login.Login" /></a>
        </div>
      </form>
    )
  }
}

export default injectIntl(IdentityForm)



// WEBPACK FOOTER //
// ./app/javascript/components/application/forgot_password/identity_form.js